import React, { useState } from "react";
import PasswordField from "../../../components/settings/PasswordField";
import { useToast } from "../../../hooks/useToast";
import axiosInstance from "../../../api/Axiosinstance";
import { ENDPOINTS } from "../../../api/Endpoints";

export default function PasswordPanel() {
  const toast = useToast();
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const [isPasswordSaving, setIsPasswordSaving] = useState(false);

  const passwordFieldsComplete = Boolean(
    passwordForm.currentPassword &&
      passwordForm.newPassword &&
      passwordForm.confirmPassword
  );

  const passwordMismatch = Boolean(
    passwordForm.newPassword &&
      passwordForm.confirmPassword &&
      passwordForm.newPassword !== passwordForm.confirmPassword
  );

  const handlePasswordSave = async () => {
    if (!passwordFieldsComplete) return;
    if (passwordMismatch) {
      toast.error("New passwords do not match.");
      return;
    }

    setIsPasswordSaving(true);
    try {
      await axiosInstance.post(ENDPOINTS.AUTH.CHANGE_PASSWORD, {
        currentPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword,
        confirmPassword: passwordForm.confirmPassword,
      });
      toast.success("Password updated successfully.");
      setPasswordForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (error) {
      toast.apiError(error, "Unable to update password.");
    } finally {
      setIsPasswordSaving(false);
    }
  };

  return (
    <div className="rounded-2xl border border-[#EEF0F3] bg-white p-5 sm:p-6 shadow-sm max-w-3xl">
      <div className="space-y-6">
        <div>
          <h2 className="text-xl font-bold text-[#6b0c44]">Change Password</h2>
          <p className="text-sm text-[#667085] mt-1">
            Create a new password you can remember easily
          </p>
        </div>

        <div className="space-y-5">
          <PasswordField
            label="Current Password"
            value={passwordForm.currentPassword}
            show={showPassword.currentPassword}
            onToggle={() =>
              setShowPassword((prev) => ({
                ...prev,
                currentPassword: !prev.currentPassword,
              }))
            }
            autoComplete="current-password"
            placeholder="Enter current password"
            onChange={(value) =>
              setPasswordForm((prev) => ({ ...prev, currentPassword: value }))
            }
          />

          <PasswordField
            label="New Password"
            value={passwordForm.newPassword}
            show={showPassword.newPassword}
            onToggle={() =>
              setShowPassword((prev) => ({
                ...prev,
                newPassword: !prev.newPassword,
              }))
            }
            autoComplete="new-password"
            placeholder="Enter new password"
            onChange={(value) =>
              setPasswordForm((prev) => ({ ...prev, newPassword: value }))
            }
          />

          <PasswordField
            label="Repeat Password"
            value={passwordForm.confirmPassword}
            show={showPassword.confirmPassword}
            onToggle={() =>
              setShowPassword((prev) => ({
                ...prev,
                confirmPassword: !prev.confirmPassword,
              }))
            }
            autoComplete="new-password"
            placeholder="Repeat new password"
            error={passwordMismatch ? "Password does not match" : null}
            onChange={(value) =>
              setPasswordForm((prev) => ({ ...prev, confirmPassword: value }))
            }
          />
        </div>

        <div className="flex justify-end border-t border-[#EEF0F3] pt-5">
          <button
            type="button"
            onClick={handlePasswordSave}
            disabled={!passwordFieldsComplete || isPasswordSaving}
            className="rounded-xl bg-[#61013B] px-6 py-3 text-base font-semibold text-white transition hover:bg-[#4d0130] disabled:cursor-not-allowed disabled:opacity-60 shadow-sm"
          >
            {isPasswordSaving ? "Saving..." : "Save changes"}
          </button>
        </div>
      </div>
    </div>
  );
}
